import {SchemaTag} from 'folder-items/FileConstants';
import {
  ComplexPolymerConnection,
  EntityAssociations,
  ResolvedAttachmentInput,
} from 'modbio/complex-polymers/ComplexPolymerConstants';
import {TagUpdateObject} from 'schemas/tags/TagUtil';
import * as net from 'util/Net';
import {Optional} from 'util/Types';

import {BackendPolymerStructureGraph} from './PolymerStructureGraphConstants';

interface ComplexPolymerCreateResponse {
  complexPolymerId: string;
}

interface ComplexPolymerUpdateReponse {
  complexPolymerId: string;
  versionId: string;
  tags: Array<SchemaTag>;
}

interface ComplexPolymerCreateParams {
  name: string;
  folderId: string;
  schemaId: string;
  tags: TagUpdateObject;
  entityAssociations: EntityAssociations;
  studyIds: Optional<Array<string>>;
  connectionInputs: Array<ComplexPolymerConnection>;
  resolvedAttachmentInputs: Array<ResolvedAttachmentInput>;
  offset?: number | null;
}

interface ComplexPolymerUpdateParams {
  entityAssociations: EntityAssociations;
  entityIds: Array<string>;
  connectionInputs: Array<ComplexPolymerConnection>;
  resolvedAttachmentInputs: Array<ResolvedAttachmentInput>;
  structureGraph: BackendPolymerStructureGraph | null;
  offset?: number;
}

export async function createComplexPolymer(
  params: ComplexPolymerCreateParams
): Promise<ComplexPolymerCreateResponse> {
  return await net.postJSONPromise({
    url: '/1/api/complex-polymers',
    data: params,
  });
}

export async function updateComplexPolymer(
  complexPolymerId: string,
  versionId: string,
  params: ComplexPolymerUpdateParams
): Promise<ComplexPolymerUpdateReponse> {
  return await net.postJSONPromise({
    url: `/1/api/complex-polymers/${complexPolymerId}-${versionId}/actions/update-structure`,
    data: params,
  });
}

export async function resetComplexPolymerVersion(
  complexPolymerId: string,
  versionId: string,
  expectedCurrentVersionId: string
): Promise<ComplexPolymerUpdateReponse> {
  return await net.postJSONPromise({
    url: `/1/api/complex-polymers/${complexPolymerId}/actions/reset-version`,
    data: {versionId, expectedCurrentVersionId},
  });
}
